import PropTypes from 'prop-types'
import classes from './YesNoButton.module.scss'
import clsx from 'clsx'
import { useGameSounds, useTranslate } from "@educaplay/core"
import { NAME_SOUND_HOVER } from "@educaplay/core"
const VARIANT_TYPES = {
    YES: "yes",
    NO: "no"
}

export function YesNoButton(props) {
    const { variant, onClick, disabled , active} = props
    const gameSounds = useGameSounds()
    const t = useTranslate();

    const buttonClasses = clsx({
        [classes.btn]: true,
        [classes.isActive]: active 
    })

    const handleHover = () => {
        gameSounds.play(NAME_SOUND_HOVER)
    }

    const hanldeClick = () => {
        gameSounds.play('yesorno-correct')
        onClick()
    }

    return (
        <button onMouseEnter={handleHover} onClick={hanldeClick} disabled={disabled} className={buttonClasses}>
            {variant === VARIANT_TYPES.YES ? t("specific.yes") : t("specific.no")}
        </button>
    )
}


YesNoButton.propTypes = {
    variant: PropTypes.oneOf(Object.values(VARIANT_TYPES)).isRequired,
    onCLick: PropTypes.func,
    disabled: PropTypes.bool
}